export interface FarmValueLike {
  id?: string;
  name?: string;
}

export interface PropertyLike {
  id?: string;
  name?: string;
  total_area?: number;
}

export interface HydratedFarmValue {
  name: string;
  id: string;
  details: {
    farmArea: number;
  };
}

/**
 * Decides whether fetched property data should be written into farmValue.
 * Guards against a stale fetch (still keyed to the farm the user just
 * switched away from) overwriting the farm that is currently selected.
 */
export const resolveHydratedFarmValue = (
  currentFarmValue: FarmValueLike | null | undefined,
  propertyData: PropertyLike | undefined
): HydratedFarmValue | null => {
  if (!propertyData?.id || !propertyData?.name) return null;
  if (currentFarmValue?.name) return null;
  if (currentFarmValue?.id && currentFarmValue.id !== propertyData.id) {
    return null;
  }

  return {
    name: propertyData.name,
    id: propertyData.id,
    details: {
      farmArea: propertyData.total_area ?? 0,
    },
  };
};
